export default function UserIcon({ className }: { className?: string }) {
  return (
    <svg
      className={`SvgIcon${className ? ` ${className}` : ""}`}
      width="24"
      height="24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <title>User avatar</title>
      <circle cx="12" cy="8" r="4" fill="currentColor" />
      <path
        d="M12 14c-5.523 0-9 2.686-9 6v2c0 .55.448 1 1 1h16c.552 0 1-.45 1-1v-2c0-3.314-3.477-6-9-6z"
        fill="currentColor"
      />
    </svg>
  );
}
